import { v4 as uuidv4 } from 'uuid';

export function SearchFetchMore(props = {}) {
	return {
		componentName: 'SearchFetchMore',
		componentId: uuidv4(),
		props: Object.assign(
			{
				htmlElementForButton: '',
			},
			props,
		),
	};
}
